import { Button, Grid } from "@material-ui/core";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { IDialogChildComponent } from "../../../reducers/dialog";


export interface IQRConfirmation extends IDialogChildComponent {
    onComplete: (venueNickname: string) => void;
    venue_nickname: string;
}



export function QRCodeConfirmation({
    onClose,
    onComplete,
    venue_nickname,
}: IQRConfirmation) {
    const [isDisabled, setIsDisabled] = useState(false);
    function onClick() {
        setIsDisabled(true);
        onComplete(venue_nickname);
    }
    const {t} = useTranslation()
    return (
        //  <ModalParent open={isOpen} onClose={onClose} style={{ width: '75%', margin: '0 auto' }}>
        <Grid container
            alignItems="center"
            spacing={3}>
            {/* {displayData()} */}
            <Grid item xs={1} />
            <Grid item xs={10}>
                <p>
                    {t("qrCode.YourCustomersText")}
                </p>
                <p>
                    https://pay.yoello.com/v/{venue_nickname}
                </p>
                <p>.
                    <b>
                    {t("qrCode.ContinueWarningText")}
                    </b>

                </p>
                <p>
                {t("qrCode.AmendUrlText")}
            </p>

            </Grid>
            <Grid item xs={1} />
            <Grid item xs={3}>
                <Button variant={'contained'} fullWidth onClick={onClose}>
                {t("qrCode.Cancel")}
                </Button>
            </Grid>
            <Grid item xs={9}>
                <Button variant={'contained'} color={'primary'} fullWidth onClick={onClick} disabled={isDisabled}>
                {t("qrCode.SaveUrl")}
            </Button>
            </Grid>

        </Grid>
    )
    // </ModalParent >
}